import type { CheckboxProps as AntdCheckboxProps } from "antd";
import { Checkbox as AntdCheckbox } from "antd";
import type { CheckboxGroupProps as AntdCheckboxGroupProps } from "antd/es/checkbox";
import React, { forwardRef } from "react";

export interface CheckboxProps extends AntdCheckboxProps {
  ariaDescribedby?: string; // Link to additional help text
  ariaLabel?: string; // Custom screen reader label
}
export interface CheckboxGroupProps extends AntdCheckboxGroupProps {
  vertical?: boolean;
}
const Checkbox = ({ ariaDescribedby, ariaLabel, ...rest }: CheckboxProps) => {
  return (
    <AntdCheckbox
      aria-describedby={ariaDescribedby} // Link to additional description
      aria-label={ariaLabel} // Screen reader label
      {...rest}
    />
  );
};

const CheckboxGroup = forwardRef<HTMLDivElement, CheckboxGroupProps>(
  ({ vertical, style, ...props }, ref) => {
    const groupStyle = vertical
      ? { display: "flex", flexDirection: "column" as const, ...style }
      : style;

    return <AntdCheckbox.Group ref={ref} style={groupStyle} {...props} />;
  }
);

Checkbox.Group = CheckboxGroup;
Checkbox.Group.displayName = "Checkbox.Group"; // Used in storybook for "Show code"

export default Checkbox;
